import {connect} from 'react-redux';
import {findSection, updateSectionValue} from '../ducks/reportSections';
import CustomiseComparableMap from './CustomiseComparableMap';
import {updatePreferences} from '../actionCreators/preferences';
import {getMarkers} from '../lib/MapUtil';

const mapStateToProps = (state) => {
  const {reportSections, reportType: {value: reportTypeValue}, propertyDetail} = state;
  const section = findSection(reportSections, reportTypeValue, 'COMPARABLE_MAP');

  const targetLatLng = propertyDetail.latitude && propertyDetail.longitude && {
    lat: propertyDetail.latitude,
    lng: propertyDetail.longitude,
  };

  return {
    reportType: reportTypeValue,
    section,
    targetLatLng,
    center: section.sectionData.center,
    zoom: section.sectionData.zoom,
    markers: [
      ...getMarkers(state, 'listings'),
      ...getMarkers(state, 'sales'),
    ],
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateSectionValue: (value, dataKeyPath, reportType) => dispatch(updateSectionValue({
      value,
      reportType,
      key: 'COMPARABLE_MAP',
      dataKeyPath: `sectionData.${dataKeyPath}`
    })),
    updatePreferences: (preferences, reportType) => dispatch(updatePreferences(preferences, reportType)),
    onMapZoomChange: (zoom, reportType) => dispatch(updateSectionValue({
      value: zoom,
      reportType,
      key: 'COMPARABLE_MAP',
      dataKeyPath: 'sectionData.zoom'
    }, true)),
    onMapCenterChange: (center, reportType) => dispatch(updateSectionValue({
      value: center,
      reportType,
      key: 'COMPARABLE_MAP',
      dataKeyPath: 'sectionData.center'
    }, true)),
  };
};

const mergeProps = (stateProps, dispatchProps) => {
  return {
    ...stateProps,
    ...dispatchProps,
    updateSectionValue: (value, dataKeyPath) => dispatchProps.updateSectionValue(value, dataKeyPath, stateProps.reportType),
    onMapZoomChange: (zoom) => dispatchProps.onMapZoomChange(zoom, stateProps.reportType),
    onMapCenterChange: (center) => dispatchProps.onMapCenterChange(center, stateProps.reportType),
  };
};

export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(CustomiseComparableMap);